var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.298,
    height: 48.159,
    viewBox: "0 0 46.298 48.159",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_001-share",
    "data-name": "001-share",
    d: "M37.144,24.24A7.332,7.332,0,0,0,31.494,26.9l-8.771-4.98a7.329,7.329,0,0,0,0-4.906l8.771-4.981A7.336,7.336,0,1,0,30.222,9.8l-8.771,4.981a7.344,7.344,0,1,0,0,9.373l8.771,4.98a7.343,7.343,0,1,0,6.922-4.892Zm0-21.67A4.775,4.775,0,1,1,32.37,7.344,4.779,4.779,0,0,1,37.144,2.57ZM15.8,24.24a4.774,4.774,0,1,1,4.774-4.774A4.78,4.78,0,0,1,15.8,24.24ZM37.144,36.36a4.775,4.775,0,1,1,4.774-4.774A4.78,4.78,0,0,1,37.144,36.36Z",
    transform: "matrix(0.951, -0.309, 0.309, 0.951, -8.042, 13.748)",
    fill: "#00868e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.acf55a512da07df2d89fe8fbc555f17c.svg";
export { ForwardRef as ReactComponent };